import React, { useRef, useEffect } from 'react';
import { Email } from '../../types/api';
import { Loader } from '../Loader';
import { EmailCard } from './EmailCard';

interface EmailThreadViewProps {
  emails: Email[];
  isLoading?: boolean;
  error?: string | null;
  isMasterDetail?: boolean;
}

export const EmailThreadView: React.FC<EmailThreadViewProps> = ({
  emails,
  isLoading = false,
  error = null,
  isMasterDetail = false
}) => {
  const messagesContainerRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    if (emails.length > 0) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  }, [emails]);

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center py-16 px-4">
        <p className="font-sans font-medium text-base text-text-subtle text-center">
          {error}
        </p>
      </div>
    );
  }

  if (emails.length === 0) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center py-16 px-4">
        <p className="font-sans font-medium text-base text-text-subtle text-center">
          No hay correos en esta conversación
        </p>
      </div>
    );
  }

  return (
    <div
      ref={messagesContainerRef}
      className={`flex-1 overflow-y-auto flex flex-col ${
        isMasterDetail ? 'pb-4' : 'pb-36'
      }`}
    >
      {/* Email thread - centered container matching WhatsApp max-width */}
      <div className="flex flex-col max-w-2xl mx-auto w-full px-4">
        {emails.map((email, index) => (
          <EmailCard
            key={email.id}
            email={email}
            isFirst={index === 0}
            isLast={index === emails.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default EmailThreadView;
